import i18n from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationAr from "./locales/ar.json";
import translationEn from "./locales/en.json";

export const AR_LANG = "ar";
export const EN_LANG = "en";
export const SUPPORTED_LANGUAGES = [AR_LANG, EN_LANG];
const resources = {
  en: {
    translation: translationEn,
  },
  ar: {
    translation: translationAr,
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(I18nextBrowserLanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    supportedLngs: SUPPORTED_LANGUAGES,
    resources,
    fallbackLng: EN_LANG,
    defaultNS: "translation",
    // Configure language detection to use localStorage
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng"
    },
    // Ensure interpolation is enabled.
    // Use single-brace positional placeholders ({0}, {1}, ...) to match the
    // shared CMS/mobile localization file byte-for-byte.
    // CONSTRAINT: because "{" / "}" are the interpolation delimiters, no
    // translation value may contain a literal brace that is not an intended
    // placeholder (e.g. code snippets, raw JSON, or ICU plural syntax like
    // "{count, plural, ...}") — it would be parsed as a variable and dropped.
    interpolation: {
      escapeValue: false, // React already does escaping
      prefix: "{",
      suffix: "}"
    }
  });

export default i18n;
